<template>
  <div class="columns mgt-20px is-multiline">
    <div class="column is-12">
      <div class="card">
        <header class="header-card">
          <p>
            {{ $t('addAgence.signataire.title')}}
          </p>
        </header>
        <app-signataire :signataire="agence.signataire"></app-signataire>
      </div>
    </div>
    <div class="column is-6">
      <div class="card">
        <header class="header-card">
          <p>
            {{ $t('addAgence.piedPageDoc')}}
          </p>
        </header>
        <div class="card-content">
          <qd-text-editor v-model="agence.piedPageHtml" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppSignataire from '@/components/general/signataireAjout';

export default {
  name: 'editionAgence',
  props: {
    agence: {
      required: true,
      type: Object,
    },
  },
  components: {
    AppSignataire,
  },
};
</script>

<style scoped>

</style>
